import log from 'loglevel';

export type TLogMessage = {
  source: string;
  message: string;
  correlationId?: string;
  stacktrace?: string;
};

export type LogLevels = 'trace' | 'error' | 'warn' | 'info' | 'debug';

log.setDefaultLevel('warn');
const getLogLevelBasedOnEnv = (): LogLevels => {
  if (process.env.REACT_APP_ENV !== 'production') {
    return 'debug';
  }
  return 'warn';
};
log.setLevel(getLogLevelBasedOnEnv());
class Logger {
  static trace({ source, message, correlationId, stacktrace }: TLogMessage) {
    log.trace({
      logLevel: 'trace',
      source,
      message,
      correlationId: correlationId || undefined,
      stacktrace: stacktrace || undefined
    });
  }
  static error(
    err: TLogMessage = {
      source: 'Logger.ts',
      message: 'Logger.error() called without arguments'
    }
  ) {
    const { source, message, correlationId, stacktrace } = err;
    log.error({
      logLevel: 'error',
      source,
      message,
      correlationId: correlationId || undefined,
      stacktrace: stacktrace || undefined
    });
  }
  static warn({ source, message, correlationId, stacktrace }: TLogMessage) {
    log.warn({
      logLevel: 'warn',
      source,
      message,
      correlationId: correlationId || undefined,
      stacktrace: stacktrace || undefined
    });
  }
  static info({ source, message, correlationId, stacktrace }: TLogMessage) {
    log.info({
      logLevel: 'info',
      source,
      message,
      correlationId: correlationId || undefined,
      stacktrace: stacktrace || undefined
    });
  }
  static debug({ source, message, correlationId, stacktrace }: TLogMessage) {
    log.debug({
      logLevel: 'debug',
      source,
      message,
      correlationId: correlationId || undefined,
      stacktrace: stacktrace || undefined
    });
  }
}

export { Logger };
